import React, { useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "../../../../redux/store";
import SVGTable from "components/_common/icons/vdm/SVGTable";
import SVGChart from "components/_common/icons/vdm/SVGChart";
import classNames from "classnames";
import WeatherReportingTable from "./_elements/WeatherReportingTable";
import WeatherReportingChart from "./_elements/WeatherReportingChart";
import vdmDashboardSelectors from "redux/app/vdmdashboard/selectors";

type OwnProps = {
	vesselId: string;
};
type VDMDashboardWeatherProps = PropsFromRedux & OwnProps;
function VDMDashboardWeather(props: VDMDashboardWeatherProps) {
	const {weatherData} = props;
	const [view, setView] = useState<"table" | "chart">("table");
	const isTableView = view === "table";

	return (
		<div>
			<div className="flex justify-end pt-4">
				<div className="inline-flex p-1.5 px-2 bg-[#F9FAFB] rounded-md gap-x-2 text-[13px]">
					<div
						onClick={() => {
							/* INFO: Not part of phase-1 */
							// setView(isTableView ? "chart" : "table")
						}}
						className={classNames(
							"flex space-x-2 items-center justify-center cursor-pointer px-4 py-1.5",
							{
								"bg-white rounded-md p-1": view === "table",
							}
						)}
					>
						<SVGTable />
						<span>Table</span>
					</div>
					<div
						onClick={() => {
							/* INFO: Not part of phase-1 */
							// setView(isTableView ? "chart" : "table")
						}}
						className={classNames(
							"flex space-x-2 items-center justify-center px-4 py-1.5 cursor-not-allowed",
							{
								"bg-white rounded-md p-1": view === "chart",
							}
						)}
					>
						<SVGChart />
						<span>Chart</span>
					</div>
				</div>
			</div>
			{isTableView ? <WeatherReportingTable weatherData={weatherData} /> : <WeatherReportingChart />}
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const vdmDashboardStore = vdmDashboardSelectors._getStore(store);
	const vdmDashboardContent = vdmDashboardSelectors.getVDMDashboardContent(vdmDashboardStore);
	const weatherData = vdmDashboardContent?.weatherData;
	return {
		weatherData
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(VDMDashboardWeather);
